export default __webpack_public_path__ + "static/media/rotate.d6ee454a.svg";